import { render } from "./AddPatient.vue?vue&type=template&id=4038f7e2&scoped=true"
import script from "./AddPatient.vue?vue&type=script&lang=js"
export * from "./AddPatient.vue?vue&type=script&lang=js"

import "./AddPatient.vue?vue&type=style&index=0&id=4038f7e2&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4038f7e2"]])

export default __exports__